import { render, staticRenderFns } from "./TariffCategoryCreate.vue?vue&type=template&id=a26259bc"
import script from "./TariffCategoryCreate.vue?vue&type=script&lang=js"
export * from "./TariffCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports